import * as i1$1 from '@activia/ngx-components';
import { FormControlComponent, AutocompleteComponent, WINDOW, ThemeType, generateThemeShades, toRgbColorString, ThemeShade, toHexColorString, CoreModule, IconModule, LoaderModule, AutocompleteModule, ModalModule, ButtonModule } from '@activia/ngx-components';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ChangeDetectionStrategy, Optional, Self, Input, Output, ViewChild, InjectionToken, Inject, Directive, ViewChildren, ContentChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { Subject, fromEvent, of, ReplaySubject, timer, BehaviorSubject, combineLatest } from 'rxjs';
import { map, takeUntil, catchError, filter, tap, startWith, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i4 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i3 from '@angular/google-maps';
import { GoogleMap, MapMarker, MapInfoWindow, GoogleMapsModule } from '@angular/google-maps';

const COUNTRIES = [
    { id: 'US', name: 'United States of America' },
    { id: 'CA', name: 'Canada' },
    { id: 'AF', name: 'Afghanistan' },
    { id: 'AX', name: 'Åland Islands' },
    { id: 'AL', name: 'Albania' },
    { id: 'DZ', name: 'Algeria' },
    { id: 'AS', name: 'American Samoa' },
    { id: 'AD', name: 'Andorra' },
    { id: 'AO', name: 'Angola' },
    { id: 'AI', name: 'Anguilla' },
    { id: 'AG', name: 'Antigua and Barbuda' },
    { id: 'AR', name: 'Argentina' },
    { id: 'AM', name: 'Armenia' },
    { id: 'AW', name: 'Aruba' },
    { id: 'AU', name: 'Australia' },
    { id: 'AT', name: 'Austria' },
    { id: 'AZ', name: 'Azerbaijan' },
    { id: 'BS', name: 'Bahamas' },
    { id: 'BH', name: 'Bahrain' },
    { id: 'BD', name: 'Bangladesh' },
    { id: 'BB', name: 'Barbados' },
    { id: 'BY', name: 'Belarus' },
    { id: 'BE', name: 'Belgium' },
    { id: 'BZ', name: 'Belize' },
    { id: 'BJ', name: 'Benin' },
    { id: 'BM', name: 'Bermuda' },
    { id: 'BT', name: 'Bhutan' },
    { id: 'BO', name: 'Bolivia, Plurinational State of' },
    { id: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
    { id: 'BA', name: 'Bosnia and Herzegovina' },
    { id: 'BW', name: 'Botswana' },
    { id: 'BV', name: 'Bouvet Island' },
    { id: 'BR', name: 'Brazil' },
    { id: 'IO', name: 'British Indian Ocean Territory' },
    { id: 'BN', name: 'Brunei Darussalam' },
    { id: 'BG', name: 'Bulgaria' },
    { id: 'BF', name: 'Burkina Faso' },
    { id: 'BI', name: 'Burundi' },
    { id: 'CV', name: 'Cabo Verde' },
    { id: 'KH', name: 'Cambodia' },
    { id: 'avn', name: 'Cameroon' },
    { id: 'KY', name: 'Cayman Islands' },
    { id: 'CF', name: 'Central African Republic' },
    { id: 'TD', name: 'Chad' },
    { id: 'CL', name: 'Chile' },
    { id: 'CN', name: 'China' },
    { id: 'CX', name: 'Christmas Island' },
    { id: 'CC', name: 'Cocos (Keeling) Islands' },
    { id: 'CO', name: 'Colombia' },
    { id: 'KM', name: 'Comoros' },
    { id: 'CD', name: 'Congo, the Democratic Republic of the' },
    { id: 'CG', name: 'Congo' },
    { id: 'CK', name: 'Cook Islands' },
    { id: 'CR', name: 'Costa Rica' },
    { id: 'CI', name: `Côte d'Ivoire` },
    { id: 'HR', name: 'Croatia' },
    { id: 'CU', name: 'Cuba' },
    { id: 'CW', name: 'Curaçao' },
    { id: 'CY', name: 'Cyprus' },
    { id: 'CZ', name: 'Czechia' },
    { id: 'DK', name: 'Denmark' },
    { id: 'DJ', name: 'Djibouti' },
    { id: 'DM', name: 'Dominica' },
    { id: 'DO', name: 'Dominican Republic' },
    { id: 'EC', name: 'Ecuador' },
    { id: 'EG', name: 'Egypt' },
    { id: 'SV', name: 'El Salvador' },
    { id: 'GQ', name: 'Equatorial Guinea' },
    { id: 'ER', name: 'Eritrea' },
    { id: 'EE', name: 'Estonia' },
    { id: 'ET', name: 'Ethiopia' },
    { id: 'FK', name: 'Falkland Islands (Malvinas)' },
    { id: 'FO', name: 'Faroe Islands' },
    { id: 'FJ', name: 'Fiji' },
    { id: 'FI', name: 'Finland' },
    { id: 'FR', name: 'France' },
    { id: 'GF', name: 'French Guiana' },
    { id: 'PF', name: 'French Polynesia' },
    { id: 'TF', name: 'French Southern Territories' },
    { id: 'GA', name: 'Gabon' },
    { id: 'GM', name: 'Gambia' },
    { id: 'GE', name: 'Georgia' },
    { id: 'DE', name: 'Germany' },
    { id: 'GH', name: 'Ghana' },
    { id: 'GI', name: 'Gibraltar' },
    { id: 'GR', name: 'Greece' },
    { id: 'GL', name: 'Greenland' },
    { id: 'GD', name: 'Grenada' },
    { id: 'GP', name: 'Guadeloupe' },
    { id: 'GU', name: 'Guam' },
    { id: 'GT', name: 'Guatemala' },
    { id: 'GG', name: 'Guernsey' },
    { id: 'GW', name: 'Guinea-Bissau' },
    { id: 'GN', name: 'Guinea' },
    { id: 'GY', name: 'Guyana' },
    { id: 'HT', name: 'Haiti' },
    { id: 'HM', name: 'Heard Island and McDonald Islands' },
    { id: 'VA', name: 'Holy See' },
    { id: 'HN', name: 'Honduras' },
    { id: 'HK', name: 'Hong Kong' },
    { id: 'HU', name: 'Hungary' },
    { id: 'IS', name: 'Iceland' },
    { id: 'IN', name: 'India' },
    { id: 'ID', name: 'Indonesia' },
    { id: 'IR', name: 'Iran, Islamic Republic of' },
    { id: 'IQ', name: 'Iraq' },
    { id: 'IE', name: 'Ireland' },
    { id: 'IM', name: 'Isle of Man' },
    { id: 'IL', name: 'Israel' },
    { id: 'IT', name: 'Italy' },
    { id: 'JM', name: 'Jamaica' },
    { id: 'JP', name: 'Japan' },
    { id: 'JE', name: 'Jersey' },
    { id: 'JO', name: 'Jordan' },
    { id: 'KZ', name: 'Kazakhstan' },
    { id: 'KE', name: 'Kenya' },
    { id: 'KI', name: 'Kiribati' },
    { id: 'KP', name: `Korea, Democratic People's Republic of` },
    { id: 'KR', name: 'Korea, Republic of' },
    { id: 'KW', name: 'Kuwait' },
    { id: 'KG', name: 'Kyrgyzstan' },
    { id: 'LA', name: `Lao People's Democratic Republic` },
    { id: 'LV', name: 'Latvia' },
    { id: 'LB', name: 'Lebanon' },
    { id: 'LS', name: 'Lesotho' },
    { id: 'LR', name: 'Liberia' },
    { id: 'LY', name: 'Libya' },
    { id: 'LI', name: 'Liechtenstein' },
    { id: 'LT', name: 'Lithuania' },
    { id: 'LU', name: 'Luxembourg' },
    { id: 'MO', name: 'Macao' },
    { id: 'MK', name: 'Macedonia, the former Yugoslav Republic of' },
    { id: 'MG', name: 'Madagascar' },
    { id: 'MW', name: 'Malawi' },
    { id: 'MY', name: 'Malaysia' },
    { id: 'MV', name: 'Maldives' },
    { id: 'ML', name: 'Mali' },
    { id: 'MT', name: 'Malta' },
    { id: 'MH', name: 'Marshall Islands' },
    { id: 'MQ', name: 'Martinique' },
    { id: 'MR', name: 'Mauritania' },
    { id: 'MU', name: 'Mauritius' },
    { id: 'YT', name: 'Mayotte' },
    { id: 'MX', name: 'Mexico' },
    { id: 'FM', name: 'Micronesia, Federated States of' },
    { id: 'MD', name: 'Moldova, Republic of' },
    { id: 'MC', name: 'Monaco' },
    { id: 'MN', name: 'Mongolia' },
    { id: 'ME', name: 'Montenegro' },
    { id: 'MS', name: 'Montserrat' },
    { id: 'MA', name: 'Morocco' },
    { id: 'MZ', name: 'Mozambique' },
    { id: 'MM', name: 'Myanmar' },
    { id: 'NA', name: 'Namibia' },
    { id: 'NR', name: 'Nauru' },
    { id: 'NP', name: 'Nepal' },
    { id: 'NL', name: 'Netherlands' },
    { id: 'NC', name: 'New Caledonia' },
    { id: 'NZ', name: 'New Zealand' },
    { id: 'NI', name: 'Nicaragua' },
    { id: 'NE', name: 'Niger' },
    { id: 'NG', name: 'Nigeria' },
    { id: 'NU', name: 'Niue' },
    { id: 'NF', name: 'Norfolk Island' },
    { id: 'MP', name: 'Northern Mariana Islands' },
    { id: 'NO', name: 'Norway' },
    { id: 'OM', name: 'Oman' },
    { id: 'PK', name: 'Pakistan' },
    { id: 'PW', name: 'Palau' },
    { id: 'PS', name: 'Palestine, State of' },
    { id: 'PA', name: 'Panama' },
    { id: 'PG', name: 'Papua New Guinea' },
    { id: 'PY', name: 'Paraguay' },
    { id: 'PE', name: 'Peru' },
    { id: 'PH', name: 'Philippines' },
    { id: 'PN', name: 'Pitcairn' },
    { id: 'PL', name: 'Poland' },
    { id: 'PT', name: 'Portugal' },
    { id: 'PR', name: 'Puerto Rico' },
    { id: 'QA', name: 'Qatar' },
    { id: 'RE', name: 'Réunion' },
    { id: 'RO', name: 'Romania' },
    { id: 'RU', name: 'Russian Federation' },
    { id: 'RW', name: 'Rwanda' },
    { id: 'BL', name: 'Saint Barthélemy' },
    { id: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
    { id: 'KN', name: 'Saint Kitts and Nevis' },
    { id: 'LC', name: 'Saint Lucia' },
    { id: 'MF', name: 'Saint Martin (French part)' },
    { id: 'PM', name: 'Saint Pierre and Miquelon' },
    { id: 'VC', name: 'Saint Vincent and the Grenadines' },
    { id: 'WS', name: 'Samoa' },
    { id: 'SM', name: 'San Marino' },
    { id: 'ST', name: 'Sao Tome and Principe' },
    { id: 'SA', name: 'Saudi Arabia' },
    { id: 'SN', name: 'Senegal' },
    { id: 'RS', name: 'Serbia' },
    { id: 'SC', name: 'Seychelles' },
    { id: 'SL', name: 'Sierra Leone' },
    { id: 'SG', name: 'Singapore' },
    { id: 'SX', name: 'Sint Maarten (Dutch part)' },
    { id: 'SK', name: 'Slovakia' },
    { id: 'SI', name: 'Slovenia' },
    { id: 'SB', name: 'Solomon Islands' },
    { id: 'SO', name: 'Somalia' },
    { id: 'ZA', name: 'South Africa' },
    { id: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { id: 'SS', name: 'South Sudan' },
    { id: 'ES', name: 'Spain' },
    { id: 'LK', name: 'Sri Lanka' },
    { id: 'SD', name: 'Sudan' },
    { id: 'SR', name: 'Suriname' },
    { id: 'SJ', name: 'Svalbard and Jan Mayen' },
    { id: 'SZ', name: 'Swaziland' },
    { id: 'SE', name: 'Sweden' },
    { id: 'CH', name: 'Switzerland' },
    { id: 'SY', name: 'Syrian Arab Republic' },
    { id: 'TW', name: 'Taiwan' },
    { id: 'TJ', name: 'Tajikistan' },
    { id: 'TZ', name: 'Tanzania, United Republic of' },
    { id: 'TH', name: 'Thailand' },
    { id: 'TL', name: 'Timor-Leste' },
    { id: 'TG', name: 'Togo' },
    { id: 'TK', name: 'Tokelau' },
    { id: 'TO', name: 'Tonga' },
    { id: 'TT', name: 'Trinidad and Tobago' },
    { id: 'TN', name: 'Tunisia' },
    { id: 'TR', name: 'Turkey' },
    { id: 'TM', name: 'Turkmenistan' },
    { id: 'TC', name: 'Turks and Caicos Islands' },
    { id: 'TV', name: 'Tuvalu' },
    { id: 'UG', name: 'Uganda' },
    { id: 'UA', name: 'Ukraine' },
    { id: 'AE', name: 'United Arab Emirates' },
    { id: 'GB', name: 'United Kingdom of Great Britain and Northern Ireland' },
    { id: 'UM', name: 'United States Minor Outlying Islands' },
    { id: 'UY', name: 'Uruguay' },
    { id: 'UZ', name: 'Uzbekistan' },
    { id: 'VU', name: 'Vanuatu' },
    { id: 'VE', name: 'Venezuela, Bolivarian Republic of' },
    { id: 'VN', name: 'Viet Nam' },
    { id: 'VG', name: 'Virgin Islands, British' },
    { id: 'VI', name: 'Virgin Islands, U.S.' },
    { id: 'WF', name: 'Wallis and Futuna' },
    { id: 'EH', name: 'Western Sahara' },
    { id: 'YE', name: 'Yemen' },
    { id: 'ZM', name: 'Zambia' },
    { id: 'ZW', name: 'Zimbabwe' },
];

const ALLCOUNTRIES = {
    id: 'ALL',
    name: 'All Countries',
};

var GeoCountryChangedEventTrigger;
(function (GeoCountryChangedEventTrigger) {
    /**
     * The user generated country selection.
     */
    GeoCountryChangedEventTrigger["USER_INITIATED"] = "userInitiated";
    /**
     * was the result of a user selecting manually.
     */
    GeoCountryChangedEventTrigger["GEO_LOCATED"] = "geoLocated";
    /**
     *  initial result.
     */
    GeoCountryChangedEventTrigger["INITIAL"] = "initial";
})(GeoCountryChangedEventTrigger || (GeoCountryChangedEventTrigger = {}));

/**
 * supported result types for the geo-search autocomplete
 */
var GeoResultTypes;
(function (GeoResultTypes) {
    /** an address including street, street number city and geo coordinates */
    GeoResultTypes["ADDRESS"] = "address";
    /** a city, town or municipality */
    GeoResultTypes["LOCALITY"] = "locality";
    /** zip or postal code */
    GeoResultTypes["ZIP_POSTAL_CODE"] = "postal_code";
})(GeoResultTypes || (GeoResultTypes = {}));

/**
 * Zoom levels for a map.
 */
var ZoomLevel;
(function (ZoomLevel) {
    ZoomLevel[ZoomLevel["COUNTRY"] = 7] = "COUNTRY";
    ZoomLevel[ZoomLevel["ADDRESS"] = 15] = "ADDRESS";
    ZoomLevel[ZoomLevel["CONTINENT"] = 3] = "CONTINENT";
    ZoomLevel[ZoomLevel["WORLD"] = 1] = "WORLD";
})(ZoomLevel || (ZoomLevel = {}));

const GAPI_KEY = 'AIzaSyAVRHf8ZFamI_X1bJDKMUtj8CgxmjZm3t0';

const GEOLOCATION_URL = `https://maps.googleapis.com/maps/api/geocode/json`;
// const GEOLOCATION_URL = 'https://maps.googleapis.com/maps/api/place/autocomplete/json';
// todo create mappers and/or validators to ensure that google maps vars are used
// OR find typings / external lib to handle this
class GoogleMapsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    fetch(search, type, country, language) {
        // https://developers.google.com/maps/faq#languagesupport
        if (!language) {
            language = 'en';
        }
        const urlParams = {
            address: search,
            key: GAPI_KEY,
            language,
        };
        if (country && country !== ALLCOUNTRIES.id) {
            // todo implement query encoder to support this model
            // https://developers.google.com/maps/documentation/geocoding/intro#ComponentFiltering
            urlParams.components = `country:${country.toLowerCase()}`;
        }
        return this.httpClient.get(GEOLOCATION_URL, { params: urlParams }).pipe(map((r) => {
            const results = r.results;
            const formattedResult = [];
            results.forEach((rz) => {
                formattedResult.push(this.parseResult(rz, type));
            });
            return formattedResult;
        }));
    }
    parseResult(res, type) {
        const selectedGeoPoint = {
            address: this.createAddressComponents(res.address_components),
            formattedAddress: res.formatted_address,
            location: {
                latitude: res.geometry.location.lat,
                longitude: res.geometry.location.lng,
            },
            resultId: res.place_id,
            type,
        };
        return selectedGeoPoint;
    }
    createAddressComponents(addressComponents) {
        const address = {
            administrativeArea1: this.tryFindAddressComponentByGoogleType(addressComponents, ['administrative_area_level_1']),
            administrativeArea2: this.tryFindAddressComponentByGoogleType(addressComponents, ['administrative_area_level_2']),
            administrativeArea3: this.tryFindAddressComponentByGoogleType(addressComponents, ['administrative_area_level_3']),
            administrativeArea4: this.tryFindAddressComponentByGoogleType(addressComponents, ['administrative_area_level_4']),
            administrativeArea5: this.tryFindAddressComponentByGoogleType(addressComponents, ['administrative_area_level_5']),
            country: {
                id: this.tryFindAddressComponentByGoogleType(addressComponents, ['country']),
                name: this.tryFindAddressComponentByGoogleType(addressComponents, ['country'], 'long_name'),
            },
            locality: this.tryFindAddressComponentByGoogleType(addressComponents, ['locality']),
            sublocalityLevel1: this.tryFindAddressComponentByGoogleType(addressComponents, ['sublocality_level_1']),
            sublocalityLevel2: this.tryFindAddressComponentByGoogleType(addressComponents, ['sublocality_level_2']),
            sublocalityLevel3: this.tryFindAddressComponentByGoogleType(addressComponents, ['sublocality_level_3']),
            sublocalityLevel4: this.tryFindAddressComponentByGoogleType(addressComponents, ['sublocality_level_4']),
            sublocalityLevel5: this.tryFindAddressComponentByGoogleType(addressComponents, ['sublocality_level_5']),
            neighborhood: this.tryFindAddressComponentByGoogleType(addressComponents, ['neighborhood']),
            postalCode: this.tryFindAddressComponentByGoogleType(addressComponents, ['postal_code']),
            street: this.tryFindAddressComponentByGoogleType(addressComponents, ['route']),
            streetNumber: this.tryFindAddressComponentByGoogleType(addressComponents, ['street_number']),
            premiseNumber: this.tryFindAddressComponentByGoogleType(addressComponents, ['subpremise']),
        };
        return address;
    }
    tryFindAddressComponentByGoogleType(addressParts, elTypos, prop = 'short_name') {
        let part = null;
        for (const typeToLookFor of elTypos) {
            const foundPart = addressParts.find((el) => el.types.findIndex((typeFromGoogle) => typeToLookFor === typeFromGoogle) > -1);
            if (foundPart) {
                part = foundPart;
                break;
            }
        }
        const resolvedPart = part ? part[prop] : null;
        return resolvedPart;
    }
}
/** @nocollapse */ /** @nocollapse */ GoogleMapsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GoogleMapsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ /** @nocollapse */ GoogleMapsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GoogleMapsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GoogleMapsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

/**
 * The avn-geo-search component allows the user to enter an address, postal / zip code or locality
 * (city) and autocompletes using google geocoding maps api.
 */
class GeoSearchComponent extends FormControlComponent {
    constructor(renderer, googleMapsService, ngControl, changeDetector) {
        super(ngControl, changeDetector);
        this.renderer = renderer;
        this.googleMapsService = googleMapsService;
        /**
         * The result type to parse.
         * see: GeoResultTypes
         */
        this.geoResultType = GeoResultTypes.ADDRESS;
        /**
         * The minimum letters before the search is triggered.
         * recommended values:
         * - GeoResultTypes.ADDRESS = 5
         * - GeoResultTypes.LOCALITY = 3
         * - GeoResultTypes.ZIP_POSTAL_CODE = 2
         */
        this.minChars = 5;
        /**
         * dispatched when the user selects an item
         * still emits if the selectedItem is the same as the current selectedItem
         */
        this.itemSelected = new EventEmitter();
        /**
         * dispatched when the selected item changes.
         * similar to itemSelected but only when the selection is different than the current value.
         */
        this.itemSelectedChange = new EventEmitter();
        /**
         * dispatched when the geo coding service cannot be reached.
         */
        this.connectivityError = new EventEmitter();
        /**
         * @ignore
         */
        this.dataSource$ = new Subject();
        /**
         * @ignore
         */
        this.displayProperty = 'formattedAddress';
        /**
         * @ignore
         */
        this.componentDestroyed$ = new Subject();
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    /**
     * @ignore
     */
    ngAfterViewInit() {
        // selection implementation
        this.autocompleteComponent.valueChanged.pipe(takeUntil(this.componentDestroyed$)).subscribe((selectedOption) => {
            this.selectedOption = selectedOption;
            const selectedGeoResult = selectedOption ? selectedOption.data : undefined;
            const selectedValue = selectedOption ? selectedOption.value : undefined;
            if (JSON.stringify(selectedValue) !== JSON.stringify(this.value)) {
                this.itemSelectedChange.emit(selectedGeoResult);
            }
            this.itemSelected.emit(selectedGeoResult);
            this.value = selectedValue;
            this.propagateChange(this.value);
        });
        // ng forms touch callback when blurred
        fromEvent(this.autocompleteComponent.autocompleteInput.nativeElement, 'blur')
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            this.onTouch();
        });
    }
    geoResultsDatasource(search) {
        let gMapsStream = this.googleMapsService.fetch(search.replace(/ /g, '+'), this.geoResultType);
        if (this.country) {
            gMapsStream = this.googleMapsService.fetch(search.replace(/ /g, '+'), this.geoResultType, this.country);
        }
        return gMapsStream.pipe(map((r) => {
            const res = r.filter((result) => {
                switch (this.geoResultType) {
                    case GeoResultTypes.ADDRESS:
                        return !!result.address;
                    case GeoResultTypes.LOCALITY:
                        return !!result.address.locality;
                    case GeoResultTypes.ZIP_POSTAL_CODE:
                        return !!result.address.postalCode;
                }
            });
            return res;
        }), map((geoResultArray) => geoResultArray.map((geoResult) => ({ value: geoResult[this.displayProperty], data: geoResult }))), catchError((err) => {
            this.connectivityError.emit(err);
            // todo validate if we return null or throw
            return of(null);
        }));
    }
    /**
     * known issue: https://github.com/angular/angular/issues/14988
     *
     * @param val
     */
    updateValue(val) {
        if (val || val === '') {
            this.value = val;
        }
        const currentlySelectedValue = this.selectedOption ? this.selectedOption.value : undefined;
        if (currentlySelectedValue !== val) {
            this.selectedOption = { value: this.value };
            this.changeDetector.detectChanges();
        }
    }
    /**
     * @ignore override from parent class so we can trigger change detection and run custom code
     * When OnPush strategy is used, inherited Input() change does not trigger ngOnChanges...
     */
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.changeDetector.detectChanges();
    }
}
/** @nocollapse */ /** @nocollapse */ GeoSearchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GeoSearchComponent, deps: [{ token: i0.Renderer2 }, { token: GoogleMapsService }, { token: i2.NgControl, optional: true, self: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ GeoSearchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.2", type: GeoSearchComponent, selector: "avn-geo-search", inputs: { country: "country", geoResultType: "geoResultType", label: "label", value: "value", placeholder: "placeholder", minChars: "minChars" }, outputs: { itemSelected: "itemSelected", itemSelectedChange: "itemSelectedChange", connectivityError: "connectivityError" }, providers: [{ provide: FormControlComponent, useExisting: GeoSearchComponent }], viewQueries: [{ propertyName: "autocompleteComponent", first: true, predicate: AutocompleteComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<avn-autocomplete\n  #autocompleteComponent\n  [id]=\"id\"\n  [disabled]=\"disabled\"\n  [datasource]=\"geoResultsDatasource.bind(this)\"\n  [selectedOption]=\"selectedOption\"\n  [label]=\"label\"\n  [placeholder]=\"placeholder\"\n  [minChars]=\"minChars\"\n  [highlightMatchingText]=\"false\"\n>\n</avn-autocomplete>\n", styles: [":host{display:block;width:100%}:host.validation-theme.ng-valid.ng-touched avn-autocomplete ::ng-deep .input-container,:host.validation-theme.ng-valid.ng-dirty avn-autocomplete ::ng-deep .input-container{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched avn-autocomplete ::ng-deep .input-container,:host.validation-theme.ng-invalid.ng-dirty avn-autocomplete ::ng-deep .input-container{border-color:var(--danger-base)!important}\n"], components: [{ type: i1$1.AutocompleteComponent, selector: "avn-autocomplete", inputs: ["optionsTemplate", "label", "datasource", "placeholder", "emptyPlaceholder", "value", "optionsListWidth", "virtualization", "autoVirtualizeAfterXOptions", "keyboardNavigationEnabled", "autoActiveFirstOption", "maxOptionsVisibleInViewport", "optionHeight", "debounceTimeMs", "minChars", "matchType", "caseSensitive", "highlightMatchingText", "highlightMatchingTextOnlyFirst", "selectedOption", "showClearInputIcon", "allowNonExistingValues"], outputs: ["valueChanged", "optionActivated", "optionListToggled"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GeoSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-geo-search', providers: [{ provide: FormControlComponent, useExisting: GeoSearchComponent }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-autocomplete\n  #autocompleteComponent\n  [id]=\"id\"\n  [disabled]=\"disabled\"\n  [datasource]=\"geoResultsDatasource.bind(this)\"\n  [selectedOption]=\"selectedOption\"\n  [label]=\"label\"\n  [placeholder]=\"placeholder\"\n  [minChars]=\"minChars\"\n  [highlightMatchingText]=\"false\"\n>\n</avn-autocomplete>\n", styles: [":host{display:block;width:100%}:host.validation-theme.ng-valid.ng-touched avn-autocomplete ::ng-deep .input-container,:host.validation-theme.ng-valid.ng-dirty avn-autocomplete ::ng-deep .input-container{border-color:var(--success-base)!important}:host.validation-theme.ng-invalid.ng-touched avn-autocomplete ::ng-deep .input-container,:host.validation-theme.ng-invalid.ng-dirty avn-autocomplete ::ng-deep .input-container{border-color:var(--danger-base)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: GoogleMapsService }, { type: i2.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { country: [{
                type: Input
            }], geoResultType: [{
                type: Input
            }], label: [{
                type: Input
            }], value: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], minChars: [{
                type: Input
            }], itemSelected: [{
                type: Output
            }], itemSelectedChange: [{
                type: Output
            }], connectivityError: [{
                type: Output
            }], autocompleteComponent: [{
                type: ViewChild,
                args: [AutocompleteComponent, { static: false }]
            }] } });

/**
 * A DI Token representing the google maps api token of an app.
 */
const MAP_API_TOKEN = new InjectionToken('MAP_API_TOKEN');

/**
 * Add the google maps api script to the application and confirms
 * the availability of maps api.
 * - current timeout to load is 2000ms.
 */
class MapsInitializerService {
    /**
     * @ignore
     */
    constructor(_window, documentRef, scrollService, gapiKey) {
        this._window = _window;
        this.documentRef = documentRef;
        this.scrollService = scrollService;
        this.gapiKey = gapiKey;
        this.initialized = undefined;
        this.googleMapInitializedSubject = new ReplaySubject(1);
        this.googleMapInitializedSubject.next(this.initialized);
    }
    /**
     * intiate the addition of google maps script.
     */
    init() {
        if (!this.initialized) {
            this.createScript(this.gapiKey, () => {
                this.initialized = true;
                this.googleMapInitializedSubject.next(this.initialized);
                this.createCustomStyle();
            });
        }
    }
    /**
     * stream of the initiated state for maps api
     * when false it is not loaded or not accessible via the clients connection
     */
    get initiated$() {
        return this.googleMapInitializedSubject.asObservable();
    }
    /**
     * removes the maps script from the document.
     */
    removeScript() {
        const gScript = this.documentRef.getElementById('googleMaps');
        gScript.remove();
        const gScripts = this.documentRef.querySelectorAll(`script[src*="maps.googleapis.com"]`);
        if (gScripts.length > 0) {
            gScripts.forEach((script) => {
                script.remove();
            });
        }
        this.initialized = undefined;
        this.googleMapInitializedSubject.next(this.initialized);
    }
    /**
     * removes the maps style from the document.
     */
    removeStyle() {
        const gStyle = this.documentRef.getElementById('googleMapsStyle');
        gStyle.remove();
    }
    /**
     * @ignore
     */
    createScript(apiKey, callback) {
        const googleMapScript = this.documentRef.getElementById('googleMaps');
        if (!googleMapScript) {
            const googleMapScriptElement = this.documentRef.createElement('script');
            googleMapScriptElement.type = 'text/javascript';
            googleMapScriptElement.id = 'googleMaps';
            googleMapScriptElement.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
            this.documentRef.head.appendChild(googleMapScriptElement);
            // todo determine threshold for not loading google maps.
            timer(2000)
                .pipe(takeUntil(this.googleMapInitializedSubject))
                .subscribe(() => {
                this.initialized = false;
                this.googleMapInitializedSubject.next(this.initialized);
            });
            this._window['initMap'] = callback;
        }
        else {
            this.initialized = true;
            this.googleMapInitializedSubject.next(this.initialized);
        }
    }
    /**
     * Override the existing map style to match the app style.
     * Currently the only change is the scrollbar style in info window.
     *
     * @ignore
     */
    createCustomStyle() {
        const googleMapStyle = this.documentRef.getElementById('googleMapsStyle');
        if (!googleMapStyle) {
            const HTMLStyleElement = this.documentRef.createElement('style');
            HTMLStyleElement.id = 'googleMapsStyle';
            const css = `.google-maps-scrollbar::-webkit-scrollbar 
        { width: ${this.scrollService.resolveScrollWidthForWebkit()} !important; height: ${this.scrollService.resolveScrollWidthForWebkit()} !important`;
            HTMLStyleElement.appendChild(document.createTextNode(css));
            this.documentRef.head.appendChild(HTMLStyleElement);
        }
    }
}
/** @nocollapse */ /** @nocollapse */ MapsInitializerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapsInitializerService, deps: [{ token: WINDOW }, { token: DOCUMENT }, { token: i1$1.ScrollService }, { token: MAP_API_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ /** @nocollapse */ MapsInitializerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapsInitializerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapsInitializerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$1.ScrollService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAP_API_TOKEN]
                }] }]; } });

var MapElementTypes;
(function (MapElementTypes) {
    MapElementTypes["MAP"] = "map";
    MapElementTypes["MARKER"] = "marker";
    MapElementTypes["CIRCLE"] = "circle";
})(MapElementTypes || (MapElementTypes = {}));
var InfoWindowTriggerTypes;
(function (InfoWindowTriggerTypes) {
    /** Info window of a marker is always shown */
    InfoWindowTriggerTypes["ALWAYS"] = "always";
    /** Info window of a marker is shown on mouseover */
    InfoWindowTriggerTypes["MOUSEOVER"] = "mouseover";
})(InfoWindowTriggerTypes || (InfoWindowTriggerTypes = {}));

var MapUnitOfMeasure;
(function (MapUnitOfMeasure) {
    MapUnitOfMeasure["KM"] = "km";
    MapUnitOfMeasure["MI"] = "mi";
})(MapUnitOfMeasure || (MapUnitOfMeasure = {}));

/**
 * This is a copy of google.maps.SymbolPath.
 * This enum contains a list of built-in icons available to use as a marker.
 *
 * {@link https://developers.google.com/maps/documentation/javascript/reference/marker#SymbolPath | Maps JavaScript API}
 */
var GoogleMapsMarkerBuiltInIcons;
(function (GoogleMapsMarkerBuiltInIcons) {
    /**
     * A circle.
     *
     * {@link https://developers.google.com/maps/documentation/javascript/reference/marker#SymbolPath.CIRCLE | Maps JavaScript API}
     */
    GoogleMapsMarkerBuiltInIcons[GoogleMapsMarkerBuiltInIcons["CIRCLE"] = 0] = "CIRCLE";
    /**
     * A forward-pointing closed arrow.
     *
     * {@link https://developers.google.com/maps/documentation/javascript/reference/marker#SymbolPath.FORWARD_CLOSED_ARROW | Maps JavaScript API}
     */
    GoogleMapsMarkerBuiltInIcons[GoogleMapsMarkerBuiltInIcons["FORWARD_CLOSED_ARROW"] = 1] = "FORWARD_CLOSED_ARROW";
    /**
     * A forward-pointing open arrow.
     *
     * {@link https://developers.google.com/maps/documentation/javascript/reference/marker#SymbolPath.FORWARD_OPEN_ARROW | Maps JavaScript API}
     */
    GoogleMapsMarkerBuiltInIcons[GoogleMapsMarkerBuiltInIcons["FORWARD_OPEN_ARROW"] = 2] = "FORWARD_OPEN_ARROW";
    /**
     * A backward-pointing closed arrow.
     *
     * {@link https://developers.google.com/maps/documentation/javascript/reference/marker#SymbolPath.BACKWARD_CLOSED_ARROW | Maps JavaScript API}
     */
    GoogleMapsMarkerBuiltInIcons[GoogleMapsMarkerBuiltInIcons["BACKWARD_CLOSED_ARROW"] = 3] = "BACKWARD_CLOSED_ARROW";
    /**
     * A backward-pointing open arrow.
     *
     * {@link https://developers.google.com/maps/documentation/javascript/reference/marker#SymbolPath.BACKWARD_OPEN_ARROW | Maps JavaScript API}
     */
    GoogleMapsMarkerBuiltInIcons[GoogleMapsMarkerBuiltInIcons["BACKWARD_OPEN_ARROW"] = 4] = "BACKWARD_OPEN_ARROW";
})(GoogleMapsMarkerBuiltInIcons || (GoogleMapsMarkerBuiltInIcons = {}));

class MapErrorMessageDirective {
    constructor() {
        /** Show the detail about the markers that cause the error in the error dialog */
        this.showErrorLog = false;
    }
}
/** @nocollapse */ /** @nocollapse */ MapErrorMessageDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapErrorMessageDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ /** @nocollapse */ MapErrorMessageDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.2", type: MapErrorMessageDirective, selector: "avn-map-error-message", inputs: { title: "title", message: "message", closeButtonLabel: "closeButtonLabel", copyErrorButtonLabel: "copyErrorButtonLabel", showErrorLog: "showErrorLog" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapErrorMessageDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'avn-map-error-message' }]
        }], propDecorators: { title: [{
                type: Input
            }], message: [{
                type: Input
            }], closeButtonLabel: [{
                type: Input
            }], copyErrorButtonLabel: [{
                type: Input
            }], showErrorLog: [{
                type: Input
            }] } });

class GoogleMapsComponent {
    constructor(renderer, themeService, googleMapInitializerService, cdr) {
        this.renderer = renderer;
        this.themeService = themeService;
        this.googleMapInitializerService = googleMapInitializerService;
        this.cdr = cdr;
        /**
         * The default theme color that will apply to loader and circles only.
         * Each circle can set its own theme by setting a value for fill directly.
         */
        this.themeColor = ThemeType.PRIMARY;
        /**
         * The initial longitude for the center of a map.
         * This sets the initial view ONLY.
         * Note that since adding a child element redraws the map extent, this input does
         * not support change detection.
         */
        this.longitude = -76.618977;
        /**
         * The initial latitude for the center of a map.
         * This sets the initial view ONLY.
         * Note that since adding a child element redraws the map extent, this input does
         * not support change detection.
         */
        this.latitude = 39.301588;
        /**
         * The initial zoom of the map.
         * This sets the initial view and can be changed externally.
         * Note that adding a child element will redraw the map extent.
         */
        this.zoom = 3;
        /** Adjust the map theme to the current theme, default to no theme adjustment. */
        this.useCurrentTheme = false;
        /** Trigger type of how the info window of markers is shown, default is on mouseover */
        this.infoWindowTriggerType = InfoWindowTriggerTypes.MOUSEOVER;
        /** Emit when user clicks on the map. Note: if the event target is undefined, the target is the map itself. */
        this.clicked = new EventEmitter();
        /** Emit when user double clicks on the map. Note: if the event target is undefined, the target is the map itself. */
        this.dblClicked = new EventEmitter();
        /** Emit when user right clicks on the map. Note: if the event target is undefined, the target is the map itself. */
        this.rightClicked = new EventEmitter();
        /** Emit error log when invalid map data are found, e.g. a marker has no valid longitude/latitude */
        this.errorLogCopied = new EventEmitter();
        /** @ignore Used in template */
        this.InfoWindowTriggerTypes = InfoWindowTriggerTypes;
        /** Indicate if map data contains error, e.g. a marker or a circle has no longitude and/or latitude */
        this.showError$ = new BehaviorSubject(false);
        this.THEME_TYPES = ThemeType;
        /** Mapping between MapMarker and MapInfoWindow */
        this.infoWindowMap = new Map();
        /** Default options that will be applied to the map */
        this.defaultMapOptions = { maxZoom: 17, mapTypeControl: false };
        this.mapDataChangeSubject = new ReplaySubject();
        this.infoWindowTriggerTypeSubject = new ReplaySubject();
        /** @ignore */
        this.componentDestroyed$ = new Subject();
        this.googleMapInitializerService.init();
        const setupData$ = combineLatest([this.googleMapInitializerService.initiated$.pipe(filter((mapApiInit) => mapApiInit)), this.mapDataChangeSubject]);
        this.circleData$ = setupData$.pipe(map(([_, mapData]) => this.processCircleOptions(mapData?.circles || [])));
        this.markerData$ = setupData$.pipe(map(([_, mapData]) => this.processMarkerOptions(mapData?.markers || [])), tap((mapData) => {
            this.infoWindowMap.forEach((value, key) => {
                // If there is an info window that is still open but marker is deleted, close and remove the info window
                if (!mapData.find((d) => d.key === key)) {
                    this.closeInfoWindow(value, key);
                }
            });
        }));
        // When the current theme changes, update the map theme when applicable
        this.themeService.theme$.pipe(takeUntil(this.componentDestroyed$)).subscribe((theme) => {
            this.currentTheme = theme;
            if (this.useCurrentTheme) {
                this.setMapTheme();
                if (this.infoWindowMap.size > 0) {
                    this.infoWindowMap.forEach((value) => {
                        this.setInfoWindowTheme(value);
                    });
                }
            }
        });
        // When the info window trigger type changes to mouseover, close all opening info windows
        this.infoWindowTriggerTypeSubject
            .pipe(filter((infoWindowTriggerType) => infoWindowTriggerType === InfoWindowTriggerTypes.MOUSEOVER), takeUntil(this.componentDestroyed$))
            .subscribe((_) => {
            this.infoWindowMap.forEach((value, key) => {
                this.closeInfoWindow(value, key);
            });
        });
    }
    /** @ignore **/
    markersChanged$() {
        return combineLatest([this.markerData$, this.mapMarkers$, this.mapInfoWindows$]).pipe(filter(([markerData, markers, infoWindows]) => markerData?.length > 0 && markerData?.length === markers?.length && markers.length === infoWindows.length));
    }
    ngOnChanges({ useCurrentTheme, data, options, infoWindowTriggerType }) {
        if (useCurrentTheme) {
            if (useCurrentTheme.currentValue) {
                this.setMapTheme();
            }
            else {
                this.options = { ...this.options, styles: undefined, ...this.defaultMapOptions };
            }
        }
        if (options) {
            if (this.useCurrentTheme) {
                this.setMapTheme();
            }
            else {
                this.options = { ...this.options, ...this.defaultMapOptions };
            }
        }
        if (data) {
            this.validateMapData(data.currentValue);
            this.mapDataChangeSubject.next(data.currentValue);
        }
        if (infoWindowTriggerType) {
            this.infoWindowTriggerTypeSubject.next(this.infoWindowTriggerType);
        }
    }
    ngAfterViewInit() {
        this.mapCompInit$ = this.map.changes.pipe(map((m) => m.length > 0), startWith(this.map.length > 0));
        this.mapMarkers$ = this.mapMarkers.changes.pipe(map((mapMarkers) => mapMarkers.toArray()), startWith(this.mapMarkers.toArray()));
        this.mapInfoWindows$ = this.mapInfoWindows.changes.pipe(map((mapInfoWindows) => mapInfoWindows.toArray()), startWith(this.mapInfoWindows.toArray()));
        this.mapError$ = this.mapError.changes.pipe(map((mapErrors) => mapErrors.first), startWith(this.mapError.first));
        combineLatest([this.mapDataChangeSubject, this.mapCompInit$.pipe(filter((mapCompInit) => mapCompInit))])
            .pipe(tap(([dataChange, _]) => {
            this.boundDataToMap(dataChange);
        }), takeUntil(this.componentDestroyed$))
            .subscribe();
        combineLatest([this.markersChanged$(), this.infoWindowTriggerTypeSubject])
            .pipe(filter(([_, infoWindowTriggerType]) => infoWindowTriggerType === InfoWindowTriggerTypes.ALWAYS), map(([[markerData, markers, infoWindows], _]) => [markerData, markers, infoWindows]), tap(([markerData, markers, infoWindows]) => {
            markers.forEach((marker, idx) => {
                const markerDatum = markerData[idx];
                if ((markerDatum.infoWindowContent || '').trim().length === 0 && this.infoWindowMap.has(markerDatum.key)) {
                    // If there is no content in the info window of this marker and the info window is opened, close it
                    this.closeInfoWindow(this.infoWindowMap.get(markerDatum.key), markerDatum.key);
                }
                else {
                    // Open or reset info window of this marker
                    // Find the info window of this marker by ID
                    const infoWindow = infoWindows.find(iw => iw['_elementRef'].nativeElement.id === markerDatum.key.toString());
                    if (infoWindow) {
                        this.openInfoWindow(marker, markerDatum, infoWindow);
                    }
                }
            });
        }), takeUntil(this.componentDestroyed$))
            .subscribe();
    }
    /** @ignore **/
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
    validateMapData(data) {
        // Reset error status when map data change
        this.setErrorStatus(false, undefined);
        if (data?.markers?.length > 0) {
            const hasInvalidMarker = data.markers.some(marker => marker.longitude == null || marker.latitude == null);
            if (hasInvalidMarker) {
                this.setErrorStatus(true, data.markers.filter(marker => marker.longitude == null || marker.latitude == null));
                data.markers = data.markers.filter(marker => marker.longitude != null && marker.latitude != null);
            }
        }
        if (data?.circles?.length > 0) {
            const hasInvalidCircle = data.circles.some(circle => circle.longitude == null || circle.latitude == null);
            if (hasInvalidCircle) {
                this.setErrorStatus(true, data.circles.filter(marker => marker.longitude == null || marker.latitude == null));
                data.circles = data.circles.filter(circle => circle.longitude != null && circle.latitude != null);
            }
        }
    }
    /** Set additional options for all markers */
    processMarkerOptions(markers) {
        markers.forEach((marker) => {
            let icon;
            if (marker.useCircleMarker) {
                icon = {
                    path: GoogleMapsMarkerBuiltInIcons.CIRCLE,
                    scale: 10,
                    strokeColor: this.themeService.resolvePaletteColor(marker.circleMarkerTheme || ThemeType.PRIMARY).toString(),
                };
            }
            else if (marker.icon) {
                icon = { url: marker.icon, scaledSize: { width: 40, height: 40 } };
            }
            marker.options = {
                ...marker.options,
                position: { lat: marker.latitude, lng: marker.longitude },
                icon,
            };
        });
        return markers;
    }
    /** Set additional options for all circles */
    processCircleOptions(circles) {
        circles.forEach((circle) => {
            const fillShades = generateThemeShades(circle.fill ? this.getThemeValue(circle.fill) : this.getThemeValue(this.themeColor));
            const circleTheme = {
                fillColor: toRgbColorString(fillShades[ThemeShade.S_500]),
                fillOpacity: 0.5,
                strokeColor: toRgbColorString(fillShades[ThemeShade.S_700]),
            };
            circle.options = {
                ...circle.options,
                ...circleTheme,
                radius: circle.radiusUnitOfMeasure === MapUnitOfMeasure.KM ? circle.radius * 1000 : circle.radius * 1609.34,
                center: { lat: circle.latitude, lng: circle.longitude },
            };
        });
        return circles;
    }
    /** Bound all markers and circles to the map */
    boundDataToMap(mapData) {
        if (mapData?.circles?.length > 0 || mapData?.markers?.length > 0) {
            // Bound all markers and circles to the map
            const mapBounds = new google.maps.LatLngBounds();
            mapData.circles?.forEach((circle) => {
                mapBounds.extend({ lat: circle.latitude, lng: circle.longitude });
            });
            mapData.markers?.forEach((marker) => {
                mapBounds.extend({ lat: marker.latitude, lng: marker.longitude });
            });
            this.map.first.fitBounds(mapBounds);
        }
        else {
            // If no data, set the map to its position
            this.map.first.center = { lat: this.latitude, lng: this.longitude };
            this.map.first.zoom = this.zoom;
        }
    }
    /** Open an info window of a marker */
    openInfoWindow(marker, markerData, markerInfoWindow) {
        // Open only if the marker has content for info window
        if (markerData.infoWindowContent?.length > 0) {
            this.infoWindowMap.set(markerData.key, markerInfoWindow);
            markerInfoWindow.domready
                .pipe(take(1), tap(() => {
                // Change the color of the close button
                this.setInfoWindowTheme(markerInfoWindow);
            }))
                .subscribe();
            markerInfoWindow.open(marker);
        }
    }
    /** Close the info window of a marker */
    closeInfoWindow(infoWindow, key) {
        infoWindow.close();
        this.infoWindowMap.delete(key);
    }
    /** When a map element is clicked */
    onClick($event, target) {
        this.clicked.emit({ event: $event, target });
    }
    /** When a map element is double-clicked */
    onDblClick($event, target) {
        this.dblClicked.emit({ event: $event, target });
    }
    /** When a map element is right-clicked */
    onRightClick($event, target) {
        this.rightClicked.emit({ event: $event, target });
    }
    setErrorStatus(showError, errors, concatError) {
        this.showError$.next(showError);
        this.errors = concatError ? this.errors.concat(errors) : errors;
    }
    getThemeValue(color) {
        return this.currentTheme[`${color}Base`] || this.currentTheme.primaryBase;
    }
    setMapElementTheme(featureType, elementType, stylers) {
        return {
            featureType,
            elementType,
            stylers,
        };
    }
    /** Set the theme of the map according to the current theme */
    setMapTheme() {
        const styles = [];
        styles.push(this.setMapElementTheme('administrative', 'labels.text.fill', [{ color: this.currentTheme.administrativeLabelsTextFill }]));
        styles.push(this.setMapElementTheme('administrative', 'labels.text.stroke', [{ color: this.currentTheme.administrativeLabelsTextStroke }]));
        styles.push(this.setMapElementTheme('landscape', 'labels.text.fill', [{ color: this.currentTheme.landscapeLabelsTextFill }]));
        styles.push(this.setMapElementTheme('landscape', 'labels.text.stroke', [{ color: this.currentTheme.landscapeLabelsTextStroke }]));
        styles.push(this.setMapElementTheme('landscape.man_made', 'all', [{ color: this.currentTheme.landscapeManmadeAll }]));
        styles.push(this.setMapElementTheme('landscape.natural', 'geometry', [{ color: this.currentTheme.landscapeNaturalGeometry }]));
        styles.push(this.setMapElementTheme('landscape.natural.terrain', 'geometry', [{ color: this.currentTheme.landscapeNaturalTerrainGeometry }]));
        styles.push(this.setMapElementTheme('poi', 'geometry', [{ color: this.currentTheme.poiGeometry }]));
        styles.push(this.setMapElementTheme('poi', 'labels.text.fill', [{ color: this.currentTheme.poiLabelsTextFill }]));
        styles.push(this.setMapElementTheme('poi', 'labels.text.stroke', [{ color: this.currentTheme.poiLabelsTextStroke }]));
        styles.push(this.setMapElementTheme('transit', 'geometry.fill', [{ color: this.currentTheme.transitGeometryFill }]));
        styles.push(this.setMapElementTheme('transit', 'labels.text.fill', [{ color: this.currentTheme.transitLabelsTextFill }]));
        styles.push(this.setMapElementTheme('transit', 'labels.text.stroke', [{ color: this.currentTheme.transitLabelsTextStroke }]));
        styles.push(this.setMapElementTheme('road', 'geometry', [{ color: this.currentTheme.roadGeometry }]));
        styles.push(this.setMapElementTheme('road', 'labels.text.fill', [{ color: this.currentTheme.roadLabelsTextFill }]));
        styles.push(this.setMapElementTheme('road', 'labels.text.stroke', [{ color: this.currentTheme.roadLabelsTextStroke }]));
        styles.push(this.setMapElementTheme('road', 'labels.icon', [{ visibility: 'on' }]));
        styles.push(this.setMapElementTheme('water', 'all', [{ color: this.currentTheme.waterAll }]));
        styles.push(this.setMapElementTheme('water', 'labels', [{ color: this.currentTheme.waterLabels }]));
        this.options = { ...this.options, styles, ...this.defaultMapOptions };
        this.cdr.detectChanges();
    }
    /** Set the theme of an info window according to the current theme */
    setInfoWindowTheme(markerInfoWindow) {
        const closeColorRegex = /fill%3D%22%23[A-Za-z0-9]{6}/gi;
        const cElement = markerInfoWindow.infoWindow.getContent().closest('.gm-style-iw-c');
        if (cElement) {
            const closeImg = cElement.querySelector('button img');
            closeImg.src = closeImg.src.replace(closeColorRegex, `fill%3D%22%23${toHexColorString(this.currentTheme.mainOn).replace('#', '')}`);
        }
        // Override the default scrollbar style in the info window to match the scrollbar style of the app
        const dElement = markerInfoWindow.infoWindow.getContent().closest('.gm-style-iw-d');
        if (dElement) {
            this.renderer.addClass(dElement, 'google-maps-scrollbar');
        }
    }
}
/** @nocollapse */ /** @nocollapse */ GoogleMapsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GoogleMapsComponent, deps: [{ token: i0.Renderer2 }, { token: i1$1.ThemeService }, { token: MapsInitializerService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ GoogleMapsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.2", type: GoogleMapsComponent, selector: "avn-google-maps", inputs: { themeColor: "themeColor", longitude: "longitude", latitude: "latitude", zoom: "zoom", useCurrentTheme: "useCurrentTheme", data: "data", options: "options", infoWindowTriggerType: "infoWindowTriggerType" }, outputs: { clicked: "clicked", dblClicked: "dblClicked", rightClicked: "rightClicked", errorLogCopied: "errorLogCopied" }, queries: [{ propertyName: "mapError", predicate: MapErrorMessageDirective }], viewQueries: [{ propertyName: "map", predicate: GoogleMap, descendants: true }, { propertyName: "mapMarkers", predicate: MapMarker, descendants: true }, { propertyName: "mapInfoWindows", predicate: MapInfoWindow, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<google-map\n  [class.has-error]=\"showError$ | async\"\n  [class.use-theme]=\"useCurrentTheme\"\n  #map=\"googleMap\"\n  *ngIf=\"googleMapInitializerService.initiated$ | async\"\n  [center]=\"{ lat: latitude, lng: longitude }\"\n  [zoom]=\"zoom\"\n  [options]=\"options\"\n  (mapClick)=\"onClick($event, undefined)\"\n  (mapDblclick)=\"onDblClick($event, undefined)\"\n  (mapRightclick)=\"onRightClick($event, undefined)\"\n>\n  <ng-container *ngIf=\"map !== null\">\n    <ng-container *ngFor=\"let marker of markerData$ | async; let idx = index\">\n      <map-marker\n        #markerEle=\"mapMarker\"\n        [options]=\"marker.options\"\n        (mapClick)=\"onClick($event, marker)\"\n        (mapDblclick)=\"onDblClick($event, marker)\"\n        (mapRightclick)=\"onRightClick($event, marker)\"\n        (mapMouseover)=\"infoWindowTriggerType !== InfoWindowTriggerTypes.ALWAYS ? openInfoWindow(markerEle, marker, markerInfoWindowEle) : undefined\"\n        (mapMouseout)=\"infoWindowTriggerType !== InfoWindowTriggerTypes.ALWAYS ? closeInfoWindow(markerInfoWindowEle, marker.key) : undefined\"\n      >\n      </map-marker>\n\n      <map-info-window #markerInfoWindowEle=\"mapInfoWindow\" [id]=\"marker.key\" [innerHTML]=\"marker.infoWindowContent\"></map-info-window>\n    </ng-container>\n\n    <map-circle\n      *ngFor=\"let circle of circleData$ | async\"\n      [options]=\"circle.options\"\n      (circleClick)=\"onClick($event, circle)\"\n      (circleDblclick)=\"onDblClick($event, circle)\"\n      (circleRightclick)=\"onRightClick($event, circle)\"\n    >\n    </map-circle>\n  </ng-container>\n</google-map>\n\n<!-- Map api is still initializing, show map loading message if it's provided -->\n<ng-content *ngIf=\"(googleMapInitializerService.initiated$ | async) === undefined\" select=\"avn-map-loading-message\"></ng-content>\n\n<!-- Map api fails to initialize, show no map message if it's provided -->\n<ng-content *ngIf=\"(googleMapInitializerService.initiated$ | async) === false\" select=\"avn-map-empty-message\"></ng-content>\n\n<ng-container *ngIf=\"googleMapInitializerService.initiated$ | async\">\n  <div *ngIf=\"(mapError$ | async) as mapError\" class=\"map-error-message\" [class.show]=\"showError$ | async\">\n    <avn-dialog-layout>\n      <avn-dialog-header [title]=\"mapError.title\"></avn-dialog-header>\n\n      <avn-dialog-content avnScroll>\n        <span>{{ mapError.message }}</span>\n        <ng-container *ngIf=\"mapError.showErrorLog\">\n          <span *ngFor=\"let error of errors\">\n          {{ error | json }}\n        </span>\n        </ng-container>\n      </avn-dialog-content>\n\n      <avn-dialog-footer>\n        <avn-button [label]=\"mapError.copyErrorButtonLabel\"\n                    (click)=\"errorLogCopied.emit(this.errors)\">\n        </avn-button>\n        <avn-button [label]=\"mapError.closeButtonLabel\"\n                    [avnTheme]=\"THEME_TYPES.PRIMARY\"\n                    (click)=\"showError$.next(false)\">\n        </avn-button>\n      </avn-dialog-footer>\n    </avn-dialog-layout>\n\n  </div>\n</ng-container>\n", styles: [":host{width:100%;height:100%;position:relative;display:flex;justify-content:center;align-items:center}:host google-map{display:block;min-height:200px;min-width:300px;width:100%;height:100%}:host google-map.disabled{display:none;visibility:hidden}:host google-map.has-error{opacity:.5}:host google-map ::ng-deep div.map-container{width:100%!important;height:100%!important}:host div.map-error-message{position:absolute;display:none;background-color:var(--modal-background);max-width:80%}:host div.map-error-message.show{display:block}:host avn-dialog-content{display:flex;flex-direction:column;padding:var(--space-md)}:host avn-dialog-content span:not(:first-child){margin-top:var(--space-md)}:host ::ng-deep .gm-style .gm-style-iw{color:#2c2c2c}:host ::ng-deep .gm-style .gm-style-iw-d{padding-right:var(--space-sm);padding-bottom:var(--space-sm)}:host .use-theme ::ng-deep .gm-style .gm-style-iw{color:var(--main-background-on)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-c{background-color:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d{background-color:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d::-webkit-scrollbar-track{background:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece{background:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d::-webkit-scrollbar-thumb{background:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-c .gm-style-iw-d::-webkit-scrollbar-thumb:hover{background-color:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-c .gm-style-iw-d::-webkit-scrollbar-corner{background-color:transparent}:host .use-theme ::ng-deep .gm-style .gm-style-iw-t:after{background:linear-gradient(45deg,var(--main-background) 50%,transparent 50%)}:host avn-loader{position:relative}:host ::ng-deep avn-map-empty-message{position:relative;top:inherit;left:inherit;transform:inherit}\n"], components: [{ type: i3.GoogleMap, selector: "google-map", inputs: ["height", "width", "mapTypeId", "center", "zoom", "options"], outputs: ["authFailure", "boundsChanged", "centerChanged", "mapClick", "mapDblclick", "mapDrag", "mapDragend", "mapDragstart", "headingChanged", "idle", "maptypeidChanged", "mapMousemove", "mapMouseout", "mapMouseover", "projectionChanged", "mapRightclick", "tilesloaded", "tiltChanged", "zoomChanged"], exportAs: ["googleMap"] }, { type: i1$1.DialogLayoutComponent, selector: "avn-dialog-layout" }, { type: i1$1.DialogHeaderComponent, selector: "avn-dialog-header", inputs: ["title", "template", "icon", "showCloseIcon"], outputs: ["closeClicked"] }, { type: i1$1.DialogContentComponent, selector: "avn-dialog-content" }, { type: i1$1.DialogFooterComponent, selector: "avn-dialog-footer" }, { type: i1$1.ButtonComponent, selector: "avn-button", inputs: ["id", "label", "type", "size", "buttonColorType", "disabled", "icon", "iconPosition"], outputs: ["actioned"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.MapMarker, selector: "map-marker", inputs: ["title", "position", "label", "clickable", "options", "icon", "visible"], outputs: ["animationChanged", "mapClick", "clickableChanged", "cursorChanged", "mapDblclick", "mapDrag", "mapDragend", "draggableChanged", "mapDragstart", "flatChanged", "iconChanged", "mapMousedown", "mapMouseout", "mapMouseover", "mapMouseup", "positionChanged", "mapRightclick", "shapeChanged", "titleChanged", "visibleChanged", "zindexChanged"], exportAs: ["mapMarker"] }, { type: i3.MapInfoWindow, selector: "map-info-window", inputs: ["options", "position"], outputs: ["closeclick", "contentChanged", "domready", "positionChanged", "zindexChanged"], exportAs: ["mapInfoWindow"] }, { type: i3.MapCircle, selector: "map-circle", inputs: ["options", "center", "radius"], outputs: ["centerChanged", "circleClick", "circleDblclick", "circleDrag", "circleDragend", "circleDragstart", "circleMousedown", "circleMousemove", "circleMouseout", "circleMouseover", "circleMouseup", "radiusChanged", "circleRightclick"], exportAs: ["mapCircle"] }, { type: i1$1.ScrollDirective, selector: "[avnScroll]", inputs: ["avnScroll", "avnScrollEmitScrollEvent"], outputs: ["scrolled"], exportAs: ["avnScroll"] }, { type: i1$1.ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }], pipes: { "async": i4.AsyncPipe, "json": i4.JsonPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GoogleMapsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-google-maps', changeDetection: ChangeDetectionStrategy.OnPush, template: "<google-map\n  [class.has-error]=\"showError$ | async\"\n  [class.use-theme]=\"useCurrentTheme\"\n  #map=\"googleMap\"\n  *ngIf=\"googleMapInitializerService.initiated$ | async\"\n  [center]=\"{ lat: latitude, lng: longitude }\"\n  [zoom]=\"zoom\"\n  [options]=\"options\"\n  (mapClick)=\"onClick($event, undefined)\"\n  (mapDblclick)=\"onDblClick($event, undefined)\"\n  (mapRightclick)=\"onRightClick($event, undefined)\"\n>\n  <ng-container *ngIf=\"map !== null\">\n    <ng-container *ngFor=\"let marker of markerData$ | async; let idx = index\">\n      <map-marker\n        #markerEle=\"mapMarker\"\n        [options]=\"marker.options\"\n        (mapClick)=\"onClick($event, marker)\"\n        (mapDblclick)=\"onDblClick($event, marker)\"\n        (mapRightclick)=\"onRightClick($event, marker)\"\n        (mapMouseover)=\"infoWindowTriggerType !== InfoWindowTriggerTypes.ALWAYS ? openInfoWindow(markerEle, marker, markerInfoWindowEle) : undefined\"\n        (mapMouseout)=\"infoWindowTriggerType !== InfoWindowTriggerTypes.ALWAYS ? closeInfoWindow(markerInfoWindowEle, marker.key) : undefined\"\n      >\n      </map-marker>\n\n      <map-info-window #markerInfoWindowEle=\"mapInfoWindow\" [id]=\"marker.key\" [innerHTML]=\"marker.infoWindowContent\"></map-info-window>\n    </ng-container>\n\n    <map-circle\n      *ngFor=\"let circle of circleData$ | async\"\n      [options]=\"circle.options\"\n      (circleClick)=\"onClick($event, circle)\"\n      (circleDblclick)=\"onDblClick($event, circle)\"\n      (circleRightclick)=\"onRightClick($event, circle)\"\n    >\n    </map-circle>\n  </ng-container>\n</google-map>\n\n<!-- Map api is still initializing, show map loading message if it's provided -->\n<ng-content *ngIf=\"(googleMapInitializerService.initiated$ | async) === undefined\" select=\"avn-map-loading-message\"></ng-content>\n\n<!-- Map api fails to initialize, show no map message if it's provided -->\n<ng-content *ngIf=\"(googleMapInitializerService.initiated$ | async) === false\" select=\"avn-map-empty-message\"></ng-content>\n\n<ng-container *ngIf=\"googleMapInitializerService.initiated$ | async\">\n  <div *ngIf=\"(mapError$ | async) as mapError\" class=\"map-error-message\" [class.show]=\"showError$ | async\">\n    <avn-dialog-layout>\n      <avn-dialog-header [title]=\"mapError.title\"></avn-dialog-header>\n\n      <avn-dialog-content avnScroll>\n        <span>{{ mapError.message }}</span>\n        <ng-container *ngIf=\"mapError.showErrorLog\">\n          <span *ngFor=\"let error of errors\">\n          {{ error | json }}\n        </span>\n        </ng-container>\n      </avn-dialog-content>\n\n      <avn-dialog-footer>\n        <avn-button [label]=\"mapError.copyErrorButtonLabel\"\n                    (click)=\"errorLogCopied.emit(this.errors)\">\n        </avn-button>\n        <avn-button [label]=\"mapError.closeButtonLabel\"\n                    [avnTheme]=\"THEME_TYPES.PRIMARY\"\n                    (click)=\"showError$.next(false)\">\n        </avn-button>\n      </avn-dialog-footer>\n    </avn-dialog-layout>\n\n  </div>\n</ng-container>\n", styles: [":host{width:100%;height:100%;position:relative;display:flex;justify-content:center;align-items:center}:host google-map{display:block;min-height:200px;min-width:300px;width:100%;height:100%}:host google-map.disabled{display:none;visibility:hidden}:host google-map.has-error{opacity:.5}:host google-map ::ng-deep div.map-container{width:100%!important;height:100%!important}:host div.map-error-message{position:absolute;display:none;background-color:var(--modal-background);max-width:80%}:host div.map-error-message.show{display:block}:host avn-dialog-content{display:flex;flex-direction:column;padding:var(--space-md)}:host avn-dialog-content span:not(:first-child){margin-top:var(--space-md)}:host ::ng-deep .gm-style .gm-style-iw{color:#2c2c2c}:host ::ng-deep .gm-style .gm-style-iw-d{padding-right:var(--space-sm);padding-bottom:var(--space-sm)}:host .use-theme ::ng-deep .gm-style .gm-style-iw{color:var(--main-background-on)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-c{background-color:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d{background-color:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d::-webkit-scrollbar-track{background:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece{background:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-d::-webkit-scrollbar-thumb{background:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-c .gm-style-iw-d::-webkit-scrollbar-thumb:hover{background-color:var(--main-background)}:host .use-theme ::ng-deep .gm-style .gm-style-iw-c .gm-style-iw-d::-webkit-scrollbar-corner{background-color:transparent}:host .use-theme ::ng-deep .gm-style .gm-style-iw-t:after{background:linear-gradient(45deg,var(--main-background) 50%,transparent 50%)}:host avn-loader{position:relative}:host ::ng-deep avn-map-empty-message{position:relative;top:inherit;left:inherit;transform:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$1.ThemeService }, { type: MapsInitializerService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { map: [{
                type: ViewChildren,
                args: [GoogleMap]
            }], mapMarkers: [{
                type: ViewChildren,
                args: [MapMarker]
            }], mapInfoWindows: [{
                type: ViewChildren,
                args: [MapInfoWindow]
            }], mapError: [{
                type: ContentChildren,
                args: [MapErrorMessageDirective]
            }], themeColor: [{
                type: Input
            }], longitude: [{
                type: Input
            }], latitude: [{
                type: Input
            }], zoom: [{
                type: Input
            }], useCurrentTheme: [{
                type: Input
            }], data: [{
                type: Input
            }], options: [{
                type: Input
            }], infoWindowTriggerType: [{
                type: Input
            }], clicked: [{
                type: Output
            }], dblClicked: [{
                type: Output
            }], rightClicked: [{
                type: Output
            }], errorLogCopied: [{
                type: Output
            }] } });

/**
 * This component can be projected into to the avn-map.
 * It is a placeholder displayed when the map api is not available.
 * It can be configured to have a icon, a main text and a sub text
 */
class MapEmptyMessageComponent {
}
/** @nocollapse */ /** @nocollapse */ MapEmptyMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapEmptyMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ MapEmptyMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.2", type: MapEmptyMessageComponent, selector: "avn-map-empty-message", inputs: { theme: "theme", icon: "icon", text: "text", subText: "subText" }, ngImport: i0, template: "<avn-icon [fontSize]=\"100\" *ngIf=\"icon\" [icon]=\"icon\" [avnTheme]=\"theme\"></avn-icon>\n<span class=\"text\" *ngIf=\"text\">{{ text }}</span>\n<span class=\"sub-text\" *ngIf=\"subText\">{{ subText }}</span>\n", styles: [":host{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;padding-left:50px;padding-right:50px;z-index:1}:host>avn-icon{margin-bottom:10px}:host>.text{font-size:var(--text-md);margin-bottom:5px}\n"], components: [{ type: i1$1.IconComponent, selector: "avn-icon", inputs: ["icon", "rotate", "fontSize", "actionId", "disabled"], outputs: ["click"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.ThemeDirective, selector: "[avnTheme]", inputs: ["avnTheme"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapEmptyMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-map-empty-message', changeDetection: ChangeDetectionStrategy.OnPush, template: "<avn-icon [fontSize]=\"100\" *ngIf=\"icon\" [icon]=\"icon\" [avnTheme]=\"theme\"></avn-icon>\n<span class=\"text\" *ngIf=\"text\">{{ text }}</span>\n<span class=\"sub-text\" *ngIf=\"subText\">{{ subText }}</span>\n", styles: [":host{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;padding-left:50px;padding-right:50px;z-index:1}:host>avn-icon{margin-bottom:10px}:host>.text{font-size:var(--text-md);margin-bottom:5px}\n"] }]
        }], propDecorators: { theme: [{
                type: Input
            }], icon: [{
                type: Input
            }], text: [{
                type: Input
            }], subText: [{
                type: Input
            }] } });

class MapLoadingMessageComponent {
}
/** @nocollapse */ /** @nocollapse */ MapLoadingMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapLoadingMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ /** @nocollapse */ MapLoadingMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.2", type: MapLoadingMessageComponent, selector: "avn-map-loading-message", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:block;width:100%;height:100%}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: MapLoadingMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'avn-map-loading-message', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: [":host{display:block;width:100%;height:100%}\n"] }]
        }] });

class GeoModule {
    static forRoot(config) {
        return {
            ngModule: GeoModule,
            providers: [
                GoogleMapsService,
                MapsInitializerService,
                // todo do this in playground app
                config.mapApi || { provide: MAP_API_TOKEN, useValue: GAPI_KEY },
            ],
        };
    }
}
/** @nocollapse */ /** @nocollapse */ GeoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GeoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ /** @nocollapse */ GeoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GeoModule, declarations: [GeoSearchComponent,
        MapEmptyMessageComponent,
        GoogleMapsComponent,
        MapLoadingMessageComponent,
        MapErrorMessageDirective], imports: [GoogleMapsModule,
        CommonModule,
        FormsModule,
        CoreModule,
        IconModule,
        LoaderModule,
        HttpClientModule,
        AutocompleteModule,
        ModalModule,
        ButtonModule], exports: [GeoSearchComponent,
        MapEmptyMessageComponent,
        GoogleMapsComponent,
        MapLoadingMessageComponent,
        MapErrorMessageDirective] });
/** @nocollapse */ /** @nocollapse */ GeoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GeoModule, providers: [
        GoogleMapsService,
        MapsInitializerService,
    ], imports: [[
            GoogleMapsModule,
            CommonModule,
            FormsModule,
            CoreModule,
            IconModule,
            LoaderModule,
            HttpClientModule,
            AutocompleteModule,
            ModalModule,
            ButtonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.2", ngImport: i0, type: GeoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GeoSearchComponent,
                        MapEmptyMessageComponent,
                        GoogleMapsComponent,
                        MapLoadingMessageComponent,
                        MapErrorMessageDirective,
                    ],
                    providers: [
                        GoogleMapsService,
                        MapsInitializerService,
                    ],
                    imports: [
                        GoogleMapsModule,
                        CommonModule,
                        FormsModule,
                        CoreModule,
                        IconModule,
                        LoaderModule,
                        HttpClientModule,
                        AutocompleteModule,
                        ModalModule,
                        ButtonModule,
                    ],
                    exports: [
                        GeoSearchComponent,
                        MapEmptyMessageComponent,
                        GoogleMapsComponent,
                        MapLoadingMessageComponent,
                        MapErrorMessageDirective,
                    ],
                }]
        }] });

/**
 * This is a copy of google.maps.ControlPosition.
 */
var IGoogleMapsControlPosition;
(function (IGoogleMapsControlPosition) {
    /** Elements are positioned in the top right and flow towards the middle. */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["TOP_LEFT"] = 1] = "TOP_LEFT";
    /** Elements are positioned in the center of the top row. */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["TOP_CENTER"] = 2] = "TOP_CENTER";
    /** Elements are positioned in the top right and flow towards the middle. */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["TOP_RIGHT"] = 3] = "TOP_RIGHT";
    /** Elements are positioned in the center of the left side. */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["LEFT_CENTER"] = 4] = "LEFT_CENTER";
    /**
     * Elements are positioned on the left, below top-left elements, and flow
     * downwards.
     */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["LEFT_TOP"] = 5] = "LEFT_TOP";
    /**
     * Elements are positioned on the left, above bottom-left elements, and flow
     * upwards.
     */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["LEFT_BOTTOM"] = 6] = "LEFT_BOTTOM";
    /** Elements are positioned on the right, below top-right elements, and flow downwards. */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["RIGHT_TOP"] = 7] = "RIGHT_TOP";
    /** Elements are positioned in the center of the right side. */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["RIGHT_CENTER"] = 8] = "RIGHT_CENTER";
    /**
     * Elements are positioned on the right, above bottom-right elements, and
     * flow upwards.
     */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["RIGHT_BOTTOM"] = 9] = "RIGHT_BOTTOM";
    /**
     * Elements are positioned in the bottom left and flow towards the middle.
     * Elements are positioned to the right of the Google logo.
     */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["BOTTOM_LEFT"] = 10] = "BOTTOM_LEFT";
    /** Elements are positioned in the center of the bottom row. */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["BOTTOM_CENTER"] = 11] = "BOTTOM_CENTER";
    /**
     * Elements are positioned in the bottom right and flow towards the middle.
     * Elements are positioned to the left of the copyrights.
     */
    IGoogleMapsControlPosition[IGoogleMapsControlPosition["BOTTOM_RIGHT"] = 12] = "BOTTOM_RIGHT";
})(IGoogleMapsControlPosition || (IGoogleMapsControlPosition = {}));
/**
 * This is a copy of google.maps.MapTypeId.
 *
 * Identifiers for common MapTypes. Specify these by value, or by using the
 * constant's name. For example, 'satellite' or
 * google.maps.MapTypeId.SATELLITE.
 */
var IGoogleMapsMapTypeId;
(function (IGoogleMapsMapTypeId) {
    /** This map type displays a transparent layer of major streets on satellite images. */
    IGoogleMapsMapTypeId["HYBRID"] = "hybrid";
    /** This map type displays a normal street map. */
    IGoogleMapsMapTypeId["ROADMAP"] = "roadmap";
    /** This map type displays satellite images. */
    IGoogleMapsMapTypeId["SATELLITE"] = "satellite";
    /** This map type displays maps with physical features such as terrain and vegetation. */
    IGoogleMapsMapTypeId["TERRAIN"] = "terrain";
})(IGoogleMapsMapTypeId || (IGoogleMapsMapTypeId = {}));
/**
 * This is a copy of google.maps.MapTypeControlStyle.
 */
var IGoogleMapsMapTypeControlStyle;
(function (IGoogleMapsMapTypeControlStyle) {
    IGoogleMapsMapTypeControlStyle[IGoogleMapsMapTypeControlStyle["DEFAULT"] = 0] = "DEFAULT";
    IGoogleMapsMapTypeControlStyle[IGoogleMapsMapTypeControlStyle["HORIZONTAL_BAR"] = 1] = "HORIZONTAL_BAR";
    IGoogleMapsMapTypeControlStyle[IGoogleMapsMapTypeControlStyle["DROPDOWN_MENU"] = 2] = "DROPDOWN_MENU";
    IGoogleMapsMapTypeControlStyle[IGoogleMapsMapTypeControlStyle["INSET"] = 3] = "INSET";
    IGoogleMapsMapTypeControlStyle[IGoogleMapsMapTypeControlStyle["INSET_LARGE"] = 4] = "INSET_LARGE";
})(IGoogleMapsMapTypeControlStyle || (IGoogleMapsMapTypeControlStyle = {}));
/**
 * This is a copy of google.maps.ZoomControlStyle.
 */
var IGoogleMapsMapZoomControlStyle;
(function (IGoogleMapsMapZoomControlStyle) {
    IGoogleMapsMapZoomControlStyle[IGoogleMapsMapZoomControlStyle["DEFAULT"] = 0] = "DEFAULT";
    IGoogleMapsMapZoomControlStyle[IGoogleMapsMapZoomControlStyle["SMALL"] = 1] = "SMALL";
    IGoogleMapsMapZoomControlStyle[IGoogleMapsMapZoomControlStyle["LARGE"] = 2] = "LARGE";
})(IGoogleMapsMapZoomControlStyle || (IGoogleMapsMapZoomControlStyle = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { ALLCOUNTRIES, COUNTRIES, GAPI_KEY, GeoCountryChangedEventTrigger, GeoModule, GeoResultTypes, GeoSearchComponent, GoogleMapsComponent, GoogleMapsMarkerBuiltInIcons, GoogleMapsService, IGoogleMapsControlPosition, IGoogleMapsMapTypeControlStyle, IGoogleMapsMapTypeId, IGoogleMapsMapZoomControlStyle, InfoWindowTriggerTypes, MAP_API_TOKEN, MapElementTypes, MapEmptyMessageComponent, MapErrorMessageDirective, MapLoadingMessageComponent, MapUnitOfMeasure, MapsInitializerService, ZoomLevel };
